import React from "react";
import ReactDOM from "react-dom";
import "popper.js/dist/popper.min.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
